import { render, staticRenderFns } from "./eduData.vue?vue&type=template&id=3c52cf5e&"
import script from "./eduData.vue?vue&type=script&lang=js&"
export * from "./eduData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports